import './styles.module.css';
export const Fonts = function Fonts() {
    return null;
};
